// Styles for LanguageSelector go here.
import { baseVariables, Modal, toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const StyledLanguageSelector = styled.div``;

export const StyledModalBody = styled(Modal.Body)`
  display: flex;
  flex-wrap: wrap;

  padding: ${toRem(24)};

  .link-item-wrapper {
    height: ${toRem(40)};
    display: flex;
    align-items: center;
    cursor: pointer;

    a {
      color: ${baseVariables.color['base10']} !important;
    }
  }

  li:hover {
    background: ${baseVariables.color['neutral10']};
  }

  a:hover {
    text-decoration: none;
    color: ${baseVariables.color['base10']};
  }

  li a {
    min-width: -webkit-fill-available;
  }
`;

export const StyledModalHeader = styled(Modal.Header)`
  height: ${toRem(88)} !important;
`;
